module.exports = __webpack_public_path__ + "img/guide8.38707c31.jpg";